<div>

  <button type="button" (click)="toggleLanguage()" class="-m-1.5 flex items-center p-1.5" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
    <span class="sr-only">Open user menu</span>
    <p class="text-white uppercase">{{ getCurrentLanguage() }}</p>
    <span class="hidden lg:flex lg:items-center">
        <svg class="ml-2 h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
        </svg>
    </span>
  </button>

</div>

<div *ngIf="isLanguageOpen" class="absolute right-0 z-50 mt-2 w-32 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
  <!-- Active: "bg-gray-100", Not Active: "" -->
  <button type="button" (click)="switchLanguage('en')" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">English</button>
  <button type="button" (click)="switchLanguage('ro')" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2">Română</button>
</div>
